'use strict';
// B.2.3.13 String.prototype.sub()
require('./_string-html')('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});



//////////////////
// WEBPACK FOOTER
// /~/babel-polyfill/~/core-js/modules/es6.string.sub.js
// module id = 746
// module chunks = 31